import React, { FunctionComponent } from "react";

import { useNullableDealerAccountInfo } from "../../stores/hooks/useNullableDealerAccountInfo";
import { NationalDescriptor } from "./NationalDescriptor";

export const HeaderAddons: FunctionComponent = () => {
  const dealer = useNullableDealerAccountInfo();

  if (!dealer) {
    return null;
  }

  return (
    <h4 className="border-l-[0.5px] border-l-paper pl-[1.5em] hidden md:block uppercase">
      <NationalDescriptor />
    </h4>
  );
};
